import Oidc from 'oidc-client'
import { MessageBox, Loading} from 'element-ui'
import commonJs from '../public/common'
import {handleError} from '../public/error-info'
// const nodeEnv = process.env.NODE_ENV

const apiHost = process.env.API_ROOT;//接口前缀地址
const saasHost = process.env.SAAS_HOST;//saas网站首页
// const saasHost = 'http://localhost:5010/';//saas网站首页
const saasAuth = process.env.SAAS_AUTH;//saas登录
const shopService = process.env.SAAS_PLATFORM; //saas 店铺绑定

// const apiHost = "https://api.vesaas.com/identityService";//接口前缀地址
// const saasHost = "https://vesaas.com/";//saas网站首页
// const saasAuth = "https://auth.vesaas.com/";//saas登录

var config = {
  authority: saasAuth,                                //SaaS后端登录页面地址
  client_id: "saas-js-client-refresh",                // TODO 非刷新token方式 saas-js-client
  clockSkew: 31536000,                                    //默认是5分钟，修改为48小时 (s)
  redirect_uri: saasHost+"portal/callback",           //登录完成成功回调地址
  silent_redirect_uri: saasHost+"portal/callback",    //登录完成回调地址
  response_type: "code",                              // TODO 非刷新token方式 id_token token
  client_secret: "secret",
  scope:"openid profile offline_access tenantIdentity fileUpload vatClient trackingYeeService PlatformShop tradeMarkRegistration productService cloudStorageService merchandiseService platformProduct carrierService salesOrderService fulfillmentService userPreferenceService salesOrderTrackingService jobcenterService contentsService businessCharge userOperationLog purchase wmsService platformOrder datastatisticsService customerService notificationService affiliateService",//
                                                      // token能够访问那些网关模块服务
  post_logout_redirect_uri: saasHost,                 //登出地址，默认首页
  accessTokenExpiringNotificationTime: 1,
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
  validateSubOnSilentRenew:false
};
var mgr = new Oidc.UserManager(config);
//监听函数，只作为调试的时候查看
mgr.events.addUserLoaded(function (user) {
  console.log('New User Loaded：', arguments);
  console.log('Acess_token: ', user.access_token)
  // localStorage["accessToken"] = user.access_token;
  localStorage.setItem('accessToken',user.access_token)
});
mgr.events.addAccessTokenExpiring(function (res) {
  console.log(res)
  console.log('addAccessTokenExpiring：', arguments);
  mgr.getUser().then(function (user) {
    console.log(user)
    console.log('Acess_token: ', user.access_token)
  })
})
mgr.events.addAccessTokenExpired(function (user) {
  console.log(res)
  console.log('addAccessTokenExpired: ', arguments);
  mgr.getUser().then(function (user) {
    console.log(user)
    console.log('Acess_token: ', user.access_token)
  })
})
const utils = {
  isLogin(permissCode,next,returnUrl){
    mgr.getUser().then(function (user) {
      var profile = localStorage['profile']?JSON.parse(localStorage['profile']):"";
      if (user) {
        localStorage["user"] = JSON.stringify(user.profile);
        if(!profile){
          commonJs.getpermissions(permissCode,permissCallback(profileData=>{
            if(profileData.indexOf(permissCode)==-1&&permissCode!=''){
              MessageBox.alert('您当前没有访问当前页面的权限，请尝试重新登录或联系管理员', {
                confirmButtonText: '确定',
                callback: action => {
                  next('/vsIndex');
                }
              });
            }else{
              next();
              localStorage.removeItem('toSaaSWhere');
            }
          }))
        }else {
          if(profile.indexOf(permissCode)==-1&&permissCode!=''){
            MessageBox.alert('您当前没有访问当前页面的权限，请尝试重新登录或联系管理员', {
              confirmButtonText: '确定',
              callback: action => {
                next('/vsIndex');
              }
            });
          }else{
            next();
            localStorage.removeItem('toSaaSWhere');
          }
        }

        localStorage["accessToken"] = user.access_token;
        // localStorage["profile"] = profile
        // next();
      }else {
        localStorage["lastHref"] = window.location.href;
        next();
        utils.login();
      }
    }).catch(e=>{
      next();
    });
  },
  justIsLogin(orLogin){
    mgr.getUser().then(function (user) {
      if (user) {
        orLogin(true);
      }else{
        orLogin(false);
      }
    })
  },

  // 请求带token的接口
  getApi(hostUrl,method,parm,callback,falseCall){
    // loading开始
    // commonJs.beginLoading();
    if(hostUrl.indexOf('http') == -1){
      hostUrl = apiHost + hostUrl;
    }
    // mgr.getUser().then(function (user) {
    //   if(user) {
        var url = hostUrl;
        var xhr = new XMLHttpRequest();
        var startTime = +new Date
        xhr.open(method, url);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.onload = function () {
          //  1.判断请求超时
          var duration = +new Date - startTime
          if(duration>=3000){
            if(localStorage['timeoutUrl']){
              let arr = JSON.parse(localStorage['timeoutUrl'])
              arr.push(url)
              let timeoutUrl = new Set(arr)
              localStorage['timeoutUrl'] = JSON.stringify(timeoutUrl)
            }else{
              let arr = []
              arr.push(url)
              localStorage['timeoutUrl'] = JSON.stringify(arr)
            }
            console.log('根据你设置的timeout请求超时 判断请求现在超时了，超时接口为：'+localStorage['timeoutUrl'])
          }
          if (xhr.status == 200) {
            // loading 关闭
            commonJs.finishLoading();
            callback(xhr.responseText);
          } else if (xhr.status == 401) {
            // loading 关闭
            commonJs.finishLoading();
            localStorage.removeItem('menuitems');
            localStorage["lastHref"] = window.location.href;
            utils.login();
          } else if (xhr.status == 500) {
            localStorage.removeItem('menuitems');
            MessageBox.alert('对不起，系统发生故障！我们正在紧急处理，请稍后再试！', {
              confirmButtonText: '确定',
              callback: action => {
                // loading 关闭
                commonJs.finishLoading();
              }
            });
          }else {
            // loading 关闭
            commonJs.finishLoading();
            localStorage.removeItem('menuitems');
            handleError(JSON.parse(xhr.responseText))
            falseCall && falseCall(xhr.responseText,xhr.status)
          }
        }
        xhr.setRequestHeader("Authorization",localStorage.getItem('accessToken')? ("Bearer " +localStorage.getItem('accessToken')):'')
        // xhr.setRequestHeader("Authorization", "Bearer " + user.access_token);
        // xhr.setRequestHeader("Authorization","Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IkJFQ0M4NUNBOTc1MDEyQTZERUMzNzk2MzczODBBN0ZGQUZGMjkzMEMiLCJ0eXAiOiJhdCtqd3QiLCJ4NXQiOiJ2c3lGeXBkUUVxYmV3M2xqYzRDbl82X3lrd3cifQ.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.Jg-9sUGJiQYTfP5QH_h3-P5SEUqe1eQCVtg-QhaqC-Sxo9njFHMNg62veGQt2TFH3d_g3-jZmmrbwO9k-4AgOr8x7l5w8c5oFNhMe6vvwcuEbuRj0Zrup_4c5kpK_oTYMNjc52KmT2JZH1vag8irpPgjwbHjzpnG5KM3iI1BF9K7Du8LSBKYj_LaBPJxicFCAyoRMAowEq7ECoiYJ24YJjmn8O0iVPR6zIUI98oEhieixrgxhkxVGVO-XyS57RazEPfmD8OEN3TMGnlxHUV8yP48j8gY1gPa4UxCChRo70d_Bwqs2pBUVpHmW9bAB35AaAiY5DEFjke932R1i81QDQ");
        xhr.send(parm);
    //   }else{
    //     utils.login();
    //   }
    // });
  },
  // 平台中心店铺绑定 请求带token的接口
  getPlatformApi(hostUrl,method,parm,callback,falseCall){
    // loading开始
    // commonJs.beginLoading();
    hostUrl = shopService + hostUrl;
    // mgr.getUser().then(function (user) {
    //   if(user) {
        var url = hostUrl;
        var xhr = new XMLHttpRequest();
        xhr.open(method, url);
        var startTime = +new Date
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.onload = function () {
          //  1.判断请求超时
          var duration = +new Date - startTime
          if(duration>=3000){
            if(localStorage['timeoutUrl']){
              let arr = JSON.parse(localStorage['timeoutUrl'])
              arr.push(url)
              let timeoutUrl = new Set(arr)
              localStorage['timeoutUrl'] = JSON.stringify(timeoutUrl)
            }else{
              let arr = []
              arr.push(url)
              localStorage['timeoutUrl'] = JSON.stringify(arr)
            }
            console.log('根据你设置的timeout请求超时 判断请求现在超时了，超时接口为：'+localStorage['timeoutUrl'])
          }
          if (xhr.status == 200) {
            // loading 关闭
            commonJs.finishLoading();
            callback(xhr.responseText);
          } else if (xhr.status == 401) {
            // loading 关闭
            commonJs.finishLoading();
            localStorage.removeItem('menuitems');
            localStorage["lastHref"] = window.location.href;
            utils.login();
          } else if (xhr.status == 500) {
            localStorage.removeItem('menuitems');
            MessageBox.alert('对不起，系统发生故障！我们正在紧急处理，请稍后再试！', {
              confirmButtonText: '确定',
              callback: action => {
                // loading 关闭
                commonJs.finishLoading();
              }
            });
          }else {
            // loading 关闭
            commonJs.finishLoading();
            localStorage.removeItem('menuitems');
            handleError(JSON.parse(xhr.responseText))
            falseCall && falseCall(xhr.responseText,xhr.status)
          }
        }
    xhr.setRequestHeader("Authorization",localStorage['accessToken']? ("Bearer " +localStorage['accessToken']):'')
        // xhr.setRequestHeader("Authorization", "Bearer " + user.access_token);
        //  xhr.setRequestHeader("Authorization","Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IkJFQ0M4NUNBOTc1MDEyQTZERUMzNzk2MzczODBBN0ZGQUZGMjkzMEMiLCJ0eXAiOiJhdCtqd3QiLCJ4NXQiOiJ2c3lGeXBkUUVxYmV3M2xqYzRDbl82X3lrd3cifQ.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.Jg-9sUGJiQYTfP5QH_h3-P5SEUqe1eQCVtg-QhaqC-Sxo9njFHMNg62veGQt2TFH3d_g3-jZmmrbwO9k-4AgOr8x7l5w8c5oFNhMe6vvwcuEbuRj0Zrup_4c5kpK_oTYMNjc52KmT2JZH1vag8irpPgjwbHjzpnG5KM3iI1BF9K7Du8LSBKYj_LaBPJxicFCAyoRMAowEq7ECoiYJ24YJjmn8O0iVPR6zIUI98oEhieixrgxhkxVGVO-XyS57RazEPfmD8OEN3TMGnlxHUV8yP48j8gY1gPa4UxCChRo70d_Bwqs2pBUVpHmW9bAB35AaAiY5DEFjke932R1i81QDQ");
        xhr.send(parm);
    //   }else{
    //     utils.login();
    //   }
    // });
  },
  // 访问公共接口
  getApiPublic(hostUrl,method,parm,callback,falseCall){
    // loading开始
    // commonJs.beginLoading();
    if(hostUrl.indexOf('http') == -1){
      hostUrl = apiHost + hostUrl;
    }
    var url = hostUrl;
    var xhr = new XMLHttpRequest();
    var startTime = +new Date
    xhr.open(method, url);
    xhr.setRequestHeader("Content-type","application/json");
    xhr.onload = function () {
      //  1.判断请求超时
      var duration = +new Date - startTime
      if(duration>=3000){
        if(localStorage['timeoutUrl']){
          let arr = JSON.parse(localStorage['timeoutUrl'])
          arr.push(url)
          let timeoutUrl = new Set(arr)
          localStorage['timeoutUrl'] = JSON.stringify(timeoutUrl)
        }else{
          let arr = []
          arr.push(url)
          localStorage['timeoutUrl'] = JSON.stringify(arr)
        }
        console.log('根据你设置的timeout请求超时 判断请求现在超时了，超时接口为：'+localStorage['timeoutUrl'])
      }
      if(xhr.status == 200){
        // loading 关闭
        commonJs.finishLoading();
        callback(xhr.responseText);
      } else if (xhr.status == 500) {
        localStorage.removeItem('menuitems');
        MessageBox.alert('对不起，系统发生故障！我们正在紧急处理，请稍后再试！', {
          confirmButtonText: '确定',
          callback: action => {
            // loading 关闭
            commonJs.finishLoading();
          }
        });
      }else{
        // loading 关闭
        commonJs.finishLoading();
        localStorage.removeItem('menuitems');
        handleError(JSON.parse(xhr.responseText))
        // falseCall(xhr.status,xhr.responseText)
      }
    }
    xhr.send(parm);
  },
  // 登录
  login() {
    //console.log("登录")
    mgr.signinRedirect();
    mgr.getUser().then(function (user) {
      if(user){
        localStorage["OidcUser1"] = JSON.stringify(user);
        localStorage["accessToken"] = user.access_token;
        localStorage["profile"] = JSON.stringify(user.profile);
      }
    });
  },
  login404(){
    location.href = saasHost+"portal/notFound";
  },
  // 登出
  loginOut() {
    //console.log("退出")
    mgr.signoutRedirect()
    localStorage.removeItem('accessToken');
    localStorage.removeItem('menuitems');
    localStorage.removeItem("lastHref");
    localStorage.removeItem("profile");
    localStorage.removeItem("user");
    localStorage.removeItem("newProductData");
    localStorage.removeItem('toSaaSWhere');
    localStorage.removeItem('returnUrl');
    //ty缓存
    localStorage.removeItem('TYcountries');
    localStorage.removeItem('TYsummary');
    localStorage.removeItem('TYtopcarriers');
    localStorage.removeItem('platfrom-all');
    localStorage.removeItem('shop-all');
    localStorage.removeItem('shippers-all');
    //shopify授权缓存
    localStorage.removeItem('shopIfyAuthData');
    localStorage.removeItem('temporaryShopId');
    localStorage.removeItem('defaultServiceName');
    sessionStorage.clear()
  },
}
export default {
  utils,
  config
};
window.login401 = utils.login;
window.login404 = utils.login404;




// WEBPACK FOOTER //
// ./src/public/oidcRoot.js